import React from 'react';
import PropTypes from 'prop-types';

import { HeroPropType } from '@/components/HeaderHero/util/heroPropType';
import * as S from './styled';
import { HeaderHero } from '../HeaderHero';

export const HeroSlide = ({ ariaRoleDescription, ariaLabel, data }) => {
  return (
    <S.Slide
      aria-roledescription={ariaRoleDescription}
      aria-label={ariaLabel}
      role="group"
      key={data}
    >
      <HeaderHero header={{ hero: [data] }} />
    </S.Slide>
  );
};

HeroSlide.propTypes = {
  ariaRoleDescription: PropTypes.string,
  ariaLabel: PropTypes.string,
  data: HeroPropType,
};
